/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_SendInputs */

const es_feedback_modal_send = /** @type {(inputs: Feedback_Modal_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar feedback`)
};

const en_feedback_modal_send = /** @type {(inputs: Feedback_Modal_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send feedback`)
};

/**
* | output |
* | --- |
* | "Send feedback" |
*
* @param {Feedback_Modal_SendInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_send = /** @type {((inputs?: Feedback_Modal_SendInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_SendInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_send(inputs)
	return en_feedback_modal_send(inputs)
});
export { feedback_modal_send as "feedback.modal.send" }